import { motion } from "framer-motion";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { scrollReveal } from "../../animation";
import { useScroll } from "./useScroll";
import Img from "react-cool-img";

const skills = [
  {
    logo: "/images/skills/python.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "Python",
    link: "https://developer.mozilla.org/en-US/docs/Glossary/Python",
  },
  {
    logo: "/images/skills/java.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "Java",
    link: "https://developer.mozilla.org/en-US/docs/Glossary/java",
  },
  {
    logo: "/images/skills/c.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "C",
    link: "https://docs.microsoft.com/en-us/cpp/c-language/?",
  },
  // {
  //   logo: "/images/skills/html.png",
  //   name: "C++",
  //   link: "https://www.w3schools.com/html/",
  // },
  {
    logo: "/images/skills/js.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "Javascript",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  {
    logo: "/images/skills/html.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "HTML5",
    link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
  },
  {
    logo: "/images/skills/css-3.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "CSS3",
    link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  },
  {
    logo: "/images/skills/typescript.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "Typescript",
    link: "https://www.typescriptlang.org/docs/",
  },
  {
    logo: "/images/skills/mysql.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "MySQL",
    link: "https://developer.mozilla.org/en-US/docs/Glossary/SQL",
  },
  {
    logo: "/images/skills/react.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "ReactJS",
    link: "https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/Client-side_JavaScript_frameworks/React_getting_started",
  },
  // {
  //   logo: "/images/skills/logo.png",
  //   name: "Material UI",
  //   link: "https://material-ui.com/",
  // },
  // {
  //   logo: "/images/skills/redux.png",
  //   name: "Redux",
  //   link: "https://redux.js.org/",
  // },
  // {
  //   logo: "/images/skills/redux.png",
  //   name: "Numpy",
  //   link: "https://redux.js.org/",
  // },
  // {
  //   logo: "/images/skills/redux.png",
  //   name: "Pandas",
  //   link: "https://redux.js.org/",
  // },
  {
    logo: "/images/skills/storybook.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "Storybook",
    link: "https://storybook.js.org/docs/react/get-started/introduction",
  },
  {
    logo: "/images/skills/streamlit.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "Streamlit",
    link: "https://docs.streamlit.io/",
  },
  {
    logo: "/images/skills/git-logo.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "Git",
    link: "https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/GitHub",
  },
  {
    logo: "/images/skills/npm.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "NPM",
    link: "https://docs.npmjs.com/",
  },
  // {
  //   logo: "/images/skills/yarn.png",
  //   // logo: "https://icon.horse/icon/python.org",
  //   name: "Yarn",
  //   link: "https://classic.yarnpkg.com/lang/en/docs/",
  // },
  {
    // logo: "/images/skills/github pages.png",
    logo: "https://icon.horse/icon/pages.github.com",
    name: "GitHub Pages",
    link: "https://docs.github.com/en/pages",
  },
  {
    logo: "/images/skills/amazon aws.png",
    // logo: "https://icon.horse/icon/python.org",
    name: "Amazon AWS",
    link: "https://docs.aws.amazon.com/",
  },
  // {
  //   logo: "/images/skills/nextjs.png",
  //   name: "Google Cloud",
  //   link: "https://nextjs.org/",
  // },
  // {
  //   logo: "/images/skills/redux.png",
  //   name: "Redux/Redux-thunk/Redux-Saga",
  //   link: "https://redux.js.org/",
  // },
  // {
  //   logo: "/images/skills/sass.png",
  //   name: "Sass",
  //   link: "https://sass-lang.com/",
  // },
  // {
  //   logo: "/images/skills/node.jpeg",
  //   name: "NodeJS",
  //   link: "https://nodejs.org/en/docs/",
  // },
  // {
  //   logo: "/images/skills/ex.jpg",
  //   name: "ExpressJS",
  //   link: "https://expressjs.com/",
  // },
  // {
  //   logo: "/images/skills/db.png",
  //   name: "MongoDB",
  //   link: "https://docs.mongodb.com/",
  // },
  // {
  //   logo: "/images/skills/sentry.png",
  //   name: "Sentry.io",
  //   link: "https://docs.sentry.io/",
  // },
  // {
  //   logo: "/images/skills/i18.png",
  //   name: "i18next",
  //   link: "https://www.i18next.com/",
  // },
];

// Unity 3D, C#, Turtoise SVN, Jira, Slack

const Skills = () => {
  const [element, controls] = useScroll();
  return (
    <div id="skills" className="skills-section">
      <motion.div
        variants={scrollReveal}
        ref={element}
        animate={controls}
        className="container"
      >
        <div className="heading-section">
          <h1>
            <span className="chonburi-font green-text">Ski</span>lls
          </h1>
        </div>
        <Row>
          {skills.map((skill, index) => {
            return (
              <Col key={index + 1}>
                <div className="skills">
                  <Img
                    placeholder="/images/skills/lod.jpeg"
                    src={skill.logo}
                    error="/images/skills/error.png"
                    alt="React Cool Img"
                  />
                  <a
                    rel="noopener noreferrer"
                    href={skill.link}
                    target="_blank"
                  >
                    {" "}
                    <h6>{skill.name}</h6>{" "}
                  </a>
                </div>
              </Col>
            );
          })}
        </Row>
      </motion.div>
    </div>
  );
};

export default Skills;
